<template>
  <div class="secure-access-container">
    <el-card class="card">
      <div v-if="loading" class="center-content">
        <el-spin tip="Validating secure link..." />
      </div>

      <div v-else-if="error" class="error-container">
        <el-card shadow="never" class="error-card">
          <div class="error-icon">🚫</div>
          <h2 class="error-title">Access Denied</h2>
          <p class="error-message">{{ error }}</p>
        </el-card>
      </div>

      <div v-else>
        <div class="file-container" v-show="fileUrl">
          <p class="file-name">File: {{ fileName }}</p>

          <iframe
            v-if="isPDF"
            :src="fileUrl"
            class="file-frame"
            frameborder="0"
          ></iframe>

          <iframe
            v-else-if="isDocOrExcel"
            :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              fileUrl
            )}`"
            class="file-frame"
            frameborder="0"
          ></iframe>

          <img
            v-else-if="isImage"
            :src="fileUrl"
            alt="Secure file"
            class="file-frame"
          />
          <a
            v-else
            :href="fileUrl"
            target="_blank"
            download
            class="el-button el-button--primary"
          >
            Download {{ fileName }}
          </a>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "@/config/axios";
import config from "@/config/app";

export default {
  name: "SecureAccessPage",
  data() {
    return {
      loading: true,
      error: null,
      fileUrl: null,
      fileType: null,
    };
  },
  computed: {
    isPDF() {
      return this.fileType === "pdf";
    },
    isImage() {
      return ["png", "jpg", "jpeg", "gif"].includes(this.fileType);
    },
    isDocOrExcel() {
      console.log("this.fileType", this.fileType);
      return ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(
        this.fileType
      );
    },
    fileName() {
      if (!this.fileUrl) return "";
      return this.fileUrl.split("/").pop().split("?")[0];
    },
  },
  mounted() {
    this.loadFile();
  },
  methods: {
    async loadFile() {
      try {
        const randomString = this.$route.params.randomString;
        const response = await axios.get(
          `${config.API_URL}/secureLink/${randomString}`
        );
        this.fileUrl = response.data.s3Url;
        const extension = this.fileUrl
          .split(".")
          .pop()
          ?.split("?")[0]
          .toLowerCase();
        this.fileType = extension;
      } catch (err) {
        this.error = err.response?.data?.error || "Something went wrong";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.secure-access-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  background: #f5f7fa;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  padding: 0;
  margin: 0;
}

.card {
  width: 100%;
  height: 100%;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.file-container {
  width: 100%;
  height: 100vh;
}

.file-frame {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.error-card {
  text-align: center;
  padding: 40px;
  border-radius: 12px;
  background: #fff5f5;
  border: 1px solid #fbc4c4;
  max-width: 400px;
}

.error-icon {
  font-size: 50px;
  margin-bottom: 15px;
}

.error-title {
  font-size: 22px;
  font-weight: bold;
  color: #d93025;
  margin-bottom: 10px;
}

.error-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}
.file-name {
  font-weight: 500;
  margin-bottom: 10px;
}

.file-frame {
  width: 100%;
  height: 600px;
  margin-bottom: 10px;
}
</style>
